<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            {{ form.id ? 'Update Accommodation' : 'Create New Accommodation' }}
          </h4>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>Name</label>
            <ValidationProvider name="name" rules="required" v-slot="{ passed, failed }">
              <fg-input type="text" :error="failed ? 'The name field is required' : null" :hasSuccess="passed" name="name"
                v-model="form.name">
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="form-group">
            <label>Code</label>
            <ValidationProvider name="fein" rules="required" v-slot="{ passed, failed }">
              <fg-input type="text" :error="failed ? 'The code field format is invalid' : null" :hasSuccess="passed"
                name="code" v-model="form.code">
              </fg-input>
            </ValidationProvider>
          </div>
          <div class="form-group">
              <label>Upgrade Order</label>
                <el-input-number v-model="form.upgrade_order" :min="1" :max="10"></el-input-number>
            </div>
        </div>
        <div class="card-footer text-right">
          <p-button type="info" native-type="submit">Save</p-button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { Accommodation } from '@/resources/accommodation'

extend("required", required);

export default {
  props: ['accommodation'],
  data() {
    return {
      form: {
        code: "",
        name: "",
      }
    };
  },
  watch: {
    accommodation: function () {
      if (this.accommodation) this.form = Object.assign({}, this.accommodation)
    }
  },
  created: function () {
    if (this.accommodation) this.form = Object.assign({}, this.accommodation)
  },
  beforeDestroy() {
    this.form = {
      code: "",
      name: "",
    }
  },
  methods: {
    submit() {
      this.$loading = true

      let request = this.form.id ? Accommodation.update(this.form) : Accommodation.create(this.form)

      request
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Accommodation has been saved',
          });
          this.$emit('save', true)
        })
        .catch(error => {
    
        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>
<style></style>
